<script lang="ts">import { stateHasSports } from "@infinitro/config";
import { loggedIn } from "@infinitro/global";
import { onDestroy, onMount } from "svelte";
import BigLeftCardLogged from "./parts/big-left-card-logged.svelte";
import BigLeftCard from "./parts/big-left-card.svelte";
import BigRightCard from "./parts/big-right-card.svelte";
import SmallBottomLeftCardFallback from "./parts/small-bottom-left-card-fallback.svelte";
import SmallBottomLeftCard from "./parts/small-bottom-left-card.svelte";
import SmallBottomRightCard from "./parts/small-bottom-right-card.svelte";
import SmallTopLeftCard from "./parts/small-top-left-card.svelte";
import SmallTopRightCard from "./parts/small-top-right-card.svelte";
let isBigScreen = window.innerWidth >= 1280;
const checkViewport = () => {
	isBigScreen = window.innerWidth >= 1280;
};
onMount(() => {
	window.addEventListener("resize", checkViewport);
});
onDestroy(() => {
	window.removeEventListener("resize", checkViewport);
});
</script>

<div class="top-section">
	<div class="first-column">
		{#if $loggedIn}
			<BigLeftCardLogged />
		{:else}
			<BigLeftCard {isBigScreen} />
		{/if}
	</div>
	<div class="second-column">
		<div class="second-column-row-1">
			<SmallTopLeftCard />
			<SmallTopRightCard />
		</div>
		<div class="second-column-row-2">
			{#if $stateHasSports}
				<SmallBottomLeftCard />
			{:else}
				<SmallBottomLeftCardFallback />
			{/if}
			<SmallBottomRightCard {isBigScreen} />
		</div>
	</div>
	<div class="third-column">
		<BigRightCard {isBigScreen} />
	</div>
</div>

<style>
	.top-section {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: stretch;
		justify-content: space-between;
		gap: 1rem;
		min-height: 235px !important;
}

	@media (min-width: 640px) {
		.top-section {
				aspect-ratio: 770/220;
		}

		@supports not (aspect-ratio: 1) {
			.top-section {
				height: calc((220 / 770) * 100%);
				width: 100%;
			}
		}
	}

	@media (min-width: 768px) {
		.top-section {
				aspect-ratio: 770/220;
			min-height: 240px !important;
		}

		@supports not (aspect-ratio: 1) {
			.top-section {
				height: calc((220 / 770) * 100%);
				width: 100%;
			}
		}
	}

	@media (min-width: 1024px) {
		.top-section {
				aspect-ratio: 770/200;
			min-height: 270px !important;
		}

		@supports not (aspect-ratio: 1) {
			.top-section {
				height: calc((200 / 770) * 100%);
				width: 100%;
			}
		}
	}

	@media (min-width: 1280px) {
		.top-section {
				aspect-ratio: 770/165;
		}

		@supports not (aspect-ratio: 1) {
			.top-section {
				height: calc((165 / 770) * 100%);
				width: 100%;
			}
		}
	}

	.first-column,
	.second-column,
	.third-column {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 1.5rem;
}

	.first-column {
		width: 30%;
}

	@media (min-width: 1280px) {
		.first-column {
				width: 23%;
		}
	}

	.second-column {
		width: 40%;
}

	@media (min-width: 1280px) {
		.second-column {
				width: 50%;
		}
	}

	.third-column {
		width: 30%;
}

	@media (min-width: 1280px) {
		.third-column {
				width: 23%;
		}
	}

	.second-column-row-1,
	.second-column-row-2 {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 0.75rem;
}
</style>
